import { render, staticRenderFns } from "./W2PPintura.vue?vue&type=template&id=40923c70"
import script from "./W2PPintura.vue?vue&type=script&lang=js"
export * from "./W2PPintura.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./W2PPintura.vue?vue&type=style&index=0&id=40923c70&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./W2PPintura.vue?vue&type=style&index=1&id=40923c70&prod&lang=scss")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports